export const toNumber = (value) => {
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;
  const number = Number(String(value ?? "").replace(",", "."));
  return Number.isFinite(number) ? number : 0;
};

const parseTax = (tax) => {
  if (!tax) return null;
  if (typeof tax === "object") return tax;

  try {
    return JSON.parse(tax);
  } catch {
    return null;
  }
};

export const getTaxRate = (source) => {
  const tax = parseTax(source?.tax ?? source?.Product?.tax);
  if (!tax || String(tax.type).toLowerCase() !== "percentage") return 0;
  return Math.max(toNumber(tax.value), 0);
};

export const priceWithTax = (price, source) => price * (1 + getTaxRate(source) / 100);

export const productPriceWithTax = (product) => priceWithTax(toNumber(product?.price), product);

// A missing snapshot needs review; it must never become a zero payment.
export const getCartTotalWithTax = cart => Number.isFinite(cart?.amounts?.total) ? cart.amounts.total : NaN;
export const getOrderTotalWithTax = order => Number.isFinite(order?.amounts?.total) ? order.amounts.total : NaN;

const euroFormatter = new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" });
export const formatMoney = value => Number.isFinite(value) ? euroFormatter.format(value) : "Pendiente de revisión";
